<mat-card appearance="outlined" class="ai-card">
  <app-card-header
    [displayName]="toolNames.getDisplayName(data().operation_id).name"
    [rawName]="data().operation_id">
  </app-card-header>

  <mat-card-content class="d-flex flex-column gap-2 px-3 pt-2 pb-2">

    <!-- Description -->
    @if (data().description) {
    <p class="mat-font-body-sm mb-0 mat-text-on-surface-variant">{{ data().description }}</p>
    }

    <!-- Method + URL row -->
    <div class="d-flex align-items-start gap-2 flex-wrap">
      <mat-chip disableRipple class="mat-font-label-sm text-uppercase">{{ data().method }}</mat-chip>
      @for (m of secondaryMethods(); track m) {
      <mat-chip disableRipple class="mat-font-label-sm text-uppercase">{{ m }}</mat-chip>
      }
      <code class="endpoint-card__url small flex-grow-1">
        @for (part of urlParts(); track $index) { @if (part.isPlaceholder) {
        <span class="endpoint-card__placeholder" [matTooltip]="part.text">⟨…⟩</span>
        } @else {
        {{ part.text }}
        } }
      </code>
    </div>

    <!-- Resolved params -->
    @if (resolvedParamEntries().length > 0) {
    <dl class="mb-0 d-flex flex-column gap-1">
      @for (entry of resolvedParamEntries(); track entry[0]) {
      <div class="d-flex align-items-baseline gap-2">
        <dt class="mat-font-label-sm mat-text-on-surface-variant flex-shrink-0">{{ entry[0] }}:</dt>
        <dd class="mb-0">
          <mat-chip disableRipple class="endpoint-card__param-chip">{{ $any(entry[1]).toString() }}</mat-chip>
        </dd>
      </div>
      }
    </dl>
    }

  </mat-card-content>
</mat-card>
